import React from "react";
import { Link, useLocation, useNavigate, Outlet, Navigate } from "react-router-dom";
import { LayoutDashboard, Package, Settings, LogOut, Tag } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import BenovaLogo from "../../components/BenovaLogo";

export default function AdminLayout() {
  const { user, checked, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  if (!checked) {
    return <div className="min-h-screen flex items-center justify-center"><div className="bn-eyebrow">Cargando...</div></div>;
  }
  if (!user || user === false) {
    return <Navigate to="/val-benova-admin-2026/login" />;
  }

  const items = [
    { path: "/val-benova-admin-2026", label: "Dashboard", icon: LayoutDashboard, exact: true },
    { path: "/val-benova-admin-2026/experiencias", label: "Experiencias", icon: Package },
    { path: "/val-benova-admin-2026/cupones", label: "Cupones", icon: Tag },
    { path: "/val-benova-admin-2026/ajustes", label: "Ajustes", icon: Settings },
  ];

  const isActive = (it) => it.exact ? loc.pathname === it.path : loc.pathname.startsWith(it.path);

  const doLogout = async () => {
    await logout();
    nav("/val-benova-admin-2026/login");
  };

  return (
    <div className="min-h-screen flex" style={{ background: "var(--bn-bg)" }} data-testid="admin-layout">
      <aside className="w-64 hidden md:flex flex-col border-r" style={{ background: "var(--bn-surface)", borderColor: "var(--bn-border)" }}>
        <div className="p-6 border-b" style={{ borderColor: "var(--bn-border)" }}>
          <BenovaLogo color="var(--bn-text)" accent="var(--bn-accent)" size="md" />
          <div className="bn-eyebrow mt-3" style={{ color: "var(--bn-accent)" }}>Admin Panel</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {items.map((it) => (
            <Link
              key={it.path}
              to={it.path}
              className="flex items-center gap-3 px-4 py-3 transition-all bn-body-font text-sm"
              style={{
                borderRadius: "var(--bn-button-radius)",
                background: isActive(it) ? "var(--bn-primary)" : "transparent",
                color: isActive(it) ? "var(--bn-primary-fg)" : "var(--bn-text)",
              }}
              data-testid={`admin-nav-${it.label.toLowerCase()}`}
            >
              <it.icon size={16} /> {it.label}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t" style={{ borderColor: "var(--bn-border)" }}>
          <div className="text-xs" style={{ color: "var(--bn-text-muted)" }}>{user.email}</div>
          <button onClick={doLogout} className="mt-3 flex items-center gap-2 text-sm hover:underline" style={{ color: "var(--bn-text)" }} data-testid="admin-logout">
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Mobile topbar */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-40 flex items-center justify-between px-5 py-3 border-b" style={{ background: "var(--bn-surface)", borderColor: "var(--bn-border)" }}>
        <BenovaLogo color="var(--bn-text)" accent="var(--bn-accent)" size="sm" />
        <button onClick={doLogout} className="bn-eyebrow" data-testid="admin-mobile-logout">Salir</button>
      </div>
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex border-t" style={{ background: "var(--bn-surface)", borderColor: "var(--bn-border)" }}>
        {items.map((it) => (
          <Link key={it.path} to={it.path} className="flex-1 flex flex-col items-center py-3 text-xs"
            style={{ color: isActive(it) ? "var(--bn-accent)" : "var(--bn-text-muted)" }}>
            <it.icon size={18} />
            <span className="mt-1">{it.label}</span>
          </Link>
        ))}
      </div>

      <main className="flex-1 pt-16 md:pt-0 pb-20 md:pb-0 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
